import { useCallback } from 'react';
import { useResourceCollection, useCreateResource, useUpdateResource, useDeleteResource, ResourceState, MutationState } from './useResource';
import { serviceItemsService } from '../services';
import { ServiceItem } from '../types';
import { ResourceQueryOptions } from '../services/resources.service';

export function useServiceItems(options?: ResourceQueryOptions): ResourceState<ServiceItem> & { meta?: any } {
  const fetchFn = useCallback(
    (opts?: ResourceQueryOptions) =>
      serviceItemsService.getAll(opts) as unknown as Promise<{ data: ServiceItem[]; meta?: any }>,
    []
  );
  return useResourceCollection<ServiceItem>(fetchFn, options);
}

export function useCreateServiceItem(onSuccess?: () => void): MutationState<ServiceItem> {
  return useCreateResource<ServiceItem>(serviceItemsService.create, onSuccess);
}

export function useUpdateServiceItem(onSuccess?: () => void): MutationState<ServiceItem> {
  return useUpdateResource<ServiceItem>(serviceItemsService.update, onSuccess);
}

export function useDeleteServiceItem(onSuccess?: () => void): MutationState<void> {
  return useDeleteResource(serviceItemsService.delete, onSuccess);
}
